
import './Ad_login.scss';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import fnc from '../mymod/commFunction';
import { useSelector, useDispatch } from 'react-redux';
import { setIsAdmin, setIsLoggedIn, setUserInfo } from '../../reduxToolkit/redux';



function Ad_login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault(); // 폼 전송에 의한 페이지 새로고침 방지
    fncAd_login(userId, password);
  };

function fncAd_login(basicid, pw) {
  
  if (!basicid || !pw) {
    alert('아이디와 비밀번호를 입력해주세요.');
    return;
  }

  // 서버에 로그인 요청
  fnc.sendAxios('/loginRoutes/selectUsersAdmin', { id: basicid, pw }, (res) => {
    console.log('서버 응답:', res);
    
    if (res.error) {
      alert(res.message || '로그인에 실패했습니다.');
      return;
    }

    if (res.success && res.data) {
      console.log('로그인 성공, 사용자 데이터:', res.data);
      const userData = res.data;
      
      dispatch(setIsLoggedIn(true));
      dispatch(setIsAdmin(true));
      dispatch(setUserInfo({
        userId: userData.id,
        userName: userData.userName || '관리자',
        userKind: userData.userKind || '',
        stCode: userData.stCode || ''
      }));
      
      console.log('navigate 실행 전');
      navigate('/admin/myroom');
      console.log('navigate 실행 후');
      
    } else {
      console.log('로그인 실패: success 또는 data 없음', res);
      alert('로그인 정보를 확인할 수 없습니다.');
    }
  });
}

function onUpdatePw() {
  navigate("/updatepw");
}

  //===============================================
  return (
    <div className='Ad_login'>
  
    <form onSubmit={handleSubmit}>
      <p className='title'>관리자 로그인</p>
      <div>
        <label htmlFor="userId">*아이디</label>
        <input
          type="text"
          id="userId"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
      </div>
      <div>
        <label htmlFor="password">*비밀번호</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <Button variant='contained' className='btnLogin' type='submit' >로그인</Button>
      {/* <Button className='btnUpdatePw' onClick={onUpdatePw}>비밀번호 수정</Button> */}
    </form>
          
    </div>
  );
}

export default Ad_login;
